import { Path } from "app/path";
import { selectAccount } from "app/redux/accountSlice";
import {
    createAppointment,
    deleteAppointment,
    deleteAppointmentGroup,
    updateAppointment,
} from "app/redux/appointmentsSlice";
import { selectBusinessServices } from "app/redux/businessServicesSlice";
import { searchClients, selectClients } from "app/redux/clientsSlice";
import { selectActiveEmployees } from "app/redux/employeesSlice";
import {
    addAppointmentRecurrencyException,
    createAppointmentFromRecurrence,
    makeAppointmentRecurrence,
    RecurrenceFrequency,
    selectSchedules,
    stopAppointmentRecurrence,
} from "app/redux/schedulesSlice";
import { selectShops } from "app/redux/shopsSlice";
import { selectWeeklySchedules } from "app/redux/weeklySchedulesSlice";
import { getFormValues } from "app/utils/getFormValues";
import { localDateToUtc, shopTimeZoneFromShop } from "app/utils/timezone";
import { useQuery } from "app/utils/useQuery";
import {
    addMinutes,
    differenceInHours,
    differenceInMinutes,
    format,
    parse,
    startOfDay,
} from "date-fns";
import { find, sortBy, uniqBy } from "lodash";
import * as React from "react";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useUpdateAppointment = ({
                                             selectedAppointmentEvent,
                                             getSchedulesOfEmployees,
                                             toggleAppointmentDrawer,
                                             setPendingAppointment,
                                             onMakeAppointmentRepeating,
                                             onEditAppointmentRepeating,
                                             onStopAppointmentRepeating,
                                             closeDrawer,
                                         }: {
    selectedAppointmentEvent: any;
    getSchedulesOfEmployees: ({ currentDate }: { currentDate?: Date }) => void;
    toggleAppointmentDrawer: (open: boolean) => void;
    setPendingAppointment: (appointment: any) => void;
    closeDrawer: () => void;
    onMakeAppointmentRepeating: (data: {
        appointmentGroup: any;
        onSave: (frequency: RecurrenceFrequency, interval: number) => Promise<void>;
    }) => void;
    onEditAppointmentRepeating: (data: {
        selectedClient: any;
        selectedServices: any[];
        parsedDate: Date;
        parsedTime: Date;
        onUpdateThisAppointmentOnly: () => Promise<void>;
        onUpdateAllFutureAppointments: () => Promise<void>;
    }) => void;
    onStopAppointmentRepeating: (data: {
        appointmentGroup: any;
        onSave: () => Promise<void>;
    }) => void;
}) => {
    const dispatch = useDispatch();
    const query = useQuery();
    const currentDate = query.get("date") as string;
    const appointmentId = query.get("appointmentId") as string;
    const phantomId = query.get("phantomId") as string;
    const navigate = useNavigate();
    const account = useSelector(selectAccount);
    const employees = useSelector(selectActiveEmployees);
    const weeklySchedules = useSelector(selectWeeklySchedules);
    const employee = selectedAppointmentEvent.employee;
    const businessServices = useSelector(selectBusinessServices);
    const { clients } = useSelector(selectClients);
    const schedules = useSelector(selectSchedules);
    const shops = useSelector(selectShops);
    const shopTimeZone = shopTimeZoneFromShop(
        shops.find((s: any) => s.id === Number(query.get("shopId")))
    );
    const [editingEmployeeInServiceIndex, setEditingEmployeeInServiceIndex] =
        useState<number | null>(null);
    const [isDateInputFocused, setIsDateInputFocused] = useState(false);
    const [selectedDate, setSelectedDate] = useState(
        selectedAppointmentEvent.start
    );
    const [specificAppointmentGroup, setSpecificAppointmentGroup] = useState<any>(
        {}
    );
    const [originalSelectedServices, setOriginalSelectedServices] = useState<
        any[]
    >([]);
    const employeeSelectRef = useRef<any>(null);
    const [availableServices, setAvailableServices] = useState(businessServices);
    const [selectedClient, setSelectedClient] = useState<any>(
        selectedAppointmentEvent.client
    );
    const [selectedServices, setSelectedServices] = useState<any[]>([]);
    const [serviceSelectValue, setServiceSelectValue] = useState<any>(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [updatingAppointment, setUpdatingAppointment] = useState<any>({})

    const isRepeating = useMemo(
        () =>
            !!selectedAppointmentEvent?.appointment?.appointmentGroup
                ?.appointmentRecurrenceId,
        [
            selectedAppointmentEvent?.appointment?.appointmentGroup
                ?.appointmentRecurrenceId,
        ]
    );

    const view = (query.get("calendarView") as "daily" | "weekly") || "daily";
    const specificDate =
        view === "weekly"
            ? format(selectedAppointmentEvent.start, "yyyy-MM-dd")
            : undefined;

    const getCurrentSchedule = useCallback(
        (
            view: "daily" | "weekly",
            specificDate: string | undefined,
            currentDate: string,
            schedules: any,
            weeklySchedules: any
        ): any => {
            if (view === "weekly") {
                const weeklyKey = Object.keys(weeklySchedules)[0];
                if (!weeklyKey) return [];
                return specificDate ? weeklySchedules[weeklyKey][specificDate] : [];
            } else {
                return specificDate
                    ? schedules[specificDate]
                    : schedules[currentDate] || {};
            }
        },
        []
    );

    const currentSchedule = useMemo(() => {
        return getCurrentSchedule(
            view,
            specificDate,
            currentDate,
            schedules,
            weeklySchedules
        );
    }, [
        view,
        specificDate,
        currentDate,
        schedules,
        weeklySchedules,
        getCurrentSchedule,
    ]);

    const allAppointmentGroups = useMemo(() => {
        if (!currentSchedule) return [];
        const res= Object.values(currentSchedule)
            .flatMap((schedule: any) => {
                if (!schedule?.appointmentGroups) return [];
                return schedule.appointmentGroups.map((group: any) => ({
                    ...group,
                    appointments:
                        group.appointments.length > 0
                            ? group.appointments
                            : schedule.appointments,
                }));
            })
            .filter((group: any) => group);

        console.log('res res',res)
return res


    }, [currentSchedule]);

    const uniqueAppointmentGroups = useMemo(
        () => [
            ...uniqBy(allAppointmentGroups, "id"),
            ...uniqBy(allAppointmentGroups, "phantomId"),
        ],
        [allAppointmentGroups]
    );

    const getSpecificAppointmentGroup = useCallback(
        ({
             appointmentId,
             phantomId,
             specificDate,
         }: {
            appointmentId?: string;
            phantomId?: string;
            specificDate?: string;
        }) => {
            const schedule = getCurrentSchedule(
                view,
                specificDate,
                currentDate,
                schedules,
                weeklySchedules
            );

            const appointmentsGroupToShow = find(
                uniqueAppointmentGroups,
                (group: any) => {
                    if (phantomId && group.phantomId) {
                        return group.appointments.some(
                            (appointment: any) => appointment.phantomId === phantomId
                        );
                    } else {
                        return group.appointments.some(
                            (appointment: any) => appointment.id === Number(appointmentId)
                        );
                    }
                }
            );
            console.log('appointmentsGroupToShow',appointmentsGroupToShow)

            if (!appointmentsGroupToShow) return null;

            const sortedAppointments = sortBy(
                appointmentsGroupToShow.appointments,
                (appointment: any) => new Date(appointment.startTime).getTime()
            );

            const result = {
                ...appointmentsGroupToShow,
                appointments: sortedAppointments,
            };

            setSpecificAppointmentGroup(result);
            return result;
        },
        [
            view,
            currentDate,
            schedules,
            weeklySchedules,
            getCurrentSchedule,
            uniqueAppointmentGroups,
        ]
    );

    const handleClientSearch = useCallback(
        async (inputValue: string, callback: any) => {
            if (inputValue.length > 2) {
                try {
                    const response = await dispatch(
                        searchClients(inputValue) as any
                    ).unwrap();
                    const results =
                        response.clients?.map((c: any) => ({
                            value: c.id,
                            label: c.name,
                            phone: c.phone,
                            email: c.email,
                            createdAt: c.createdAt,
                            avatar: c.avatar,
                        })) || [];
                    callback(results);
                } catch (error) {
                    console.error("Error searching clients:", error);
                }
            } else {
                return [];
            }
        },
        [dispatch]
    );


    const saleForSelectedAppointment=useMemo(()=>{
        return selectedAppointmentEvent.sale
    },[selectedAppointmentEvent])

    const onHandleClientChange = useCallback((selectedOption: any) => {
        setSelectedClient({
            ...selectedOption,
            id: selectedOption.value,
            name: selectedOption.label,
        });
    }, []);

    const updateSelectedServicesWithStartTimes = useCallback(
        ({
             appointmentId,
             setSelectedServices,
         }: {
            appointmentId: string;
            setSelectedServices: React.Dispatch<React.SetStateAction<any[]>>;
        }) => {
            const specificDate =
                view === "weekly"
                    ? format(selectedAppointmentEvent.start, "yyyy-MM-dd")
                    : undefined;

            const appointmentsGroupToShow = getSpecificAppointmentGroup({
                appointmentId,
                phantomId,
                specificDate,
            });

            if (appointmentsGroupToShow) {
                const servicesWithStartTimes =
                    appointmentsGroupToShow.appointments.flatMap((appointment: any) => {
                        let currentStartTime = new Date(
                            appointment.startTime
                        );

                        return appointment.services.map((service: any) => {
                            const startAtTime = format(currentStartTime, "hh:mm a");
                            currentStartTime = addMinutes(currentStartTime, service.duration);

                            return {
                                ...service,
                                startAtTime,
                            };
                        });
                    });

                setSelectedServices(servicesWithStartTimes);
                setOriginalSelectedServices(servicesWithStartTimes);
            }
        },
        [
            view,
            selectedAppointmentEvent.start,
            getSpecificAppointmentGroup,
            phantomId,
        ]
    );

    const onRemoveService = useCallback(
        (index: number) => {
            setSelectedServices((prevServices) => {
                const updatedServices = [...prevServices];
                updatedServices.splice(index, 1);

                let lastServiceEndTime: Date | undefined;

                return updatedServices.map((service, idx) => {
                    if (idx === 0) {
                        lastServiceEndTime = new Date(
                            getSpecificAppointmentGroup({
                                appointmentId: selectedAppointmentEvent.appointment.id,
                                phantomId: selectedAppointmentEvent.appointment.phantomId,
                                specificDate: format(
                                    selectedAppointmentEvent.start,
                                    "yyyy-MM-dd"
                                ),
                            }).appointments[0].startTime
                        );
                    }

                    const serviceStartTime = lastServiceEndTime || new Date();
                    lastServiceEndTime = addMinutes(serviceStartTime, service.duration);

                    return {
                        ...service,
                        startAtTime: format(serviceStartTime, "hh:mm a"),
                    };
                });
            });
        },
        [selectedAppointmentEvent, getSpecificAppointmentGroup]
    );

    const onHandleAddService = useCallback(
        (selectedOption: any) => {
            const employeeService = find(
                employee!.services,
                (service) => service.businessService.id === selectedOption.value
            );

            if (!employeeService) {
                console.error("Employee service not found");
                return;
            }

            let lastServiceEndTime: Date | undefined;

            if (selectedServices.length > 0) {
                const lastService = selectedServices[selectedServices.length - 1];
                lastServiceEndTime = addMinutes(
                    parse(lastService.startAtTime, "hh:mm a", new Date()),
                    lastService.duration
                );
            } else {
                try {
                    lastServiceEndTime = new Date(
                        getSpecificAppointmentGroup({
                            appointmentId: selectedAppointmentEvent.appointment.id,
                            phantomId: selectedAppointmentEvent.appointment.phantomId,
                            specificDate: format(
                                selectedAppointmentEvent.start,
                                "yyyy-MM-dd"
                            ),
                        }).appointments[0].startTime
                    );
                } catch (error) {
                    console.error("Error getting appointment start time:", error);
                    lastServiceEndTime = new Date();
                }
            }

            const newServiceStartTime = lastServiceEndTime;
            const newServiceWithTime = {
                ...employeeService,
                startAtTime: format(newServiceStartTime, "hh:mm a"),
            };

            setSelectedServices((prev) => [...prev, newServiceWithTime]);

            setAvailableServices((prev) =>
                prev.map((category) => ({
                    ...category,
                    services: category.services.filter(
                        (service: any) => service.id !== selectedOption.value
                    ),
                }))
            );

            setServiceSelectValue(null);
        },
        [
            employee,
            selectedServices,
            selectedAppointmentEvent,
            getSpecificAppointmentGroup,
        ]
    );

    const handleEmployeeChange = useCallback(
        (serviceIndex: number, selectedOption: any) => {
            setSelectedServices((prevServices) => {
                const updatedServices = [...prevServices];
                const newEmployee = employees.find(
                    (emp) => emp.id === selectedOption.value
                );
                const newEmployeeService = newEmployee?.services.find(
                    (service) =>
                        service.businessService.id ===
                        updatedServices[serviceIndex].businessService.id
                );

                updatedServices[serviceIndex] = {
                    ...updatedServices[serviceIndex],
                    employee: newEmployee,
                    id: newEmployeeService.id,
                    price: newEmployeeService.price,
                    priceCents: newEmployeeService.priceCents,
                    status: newEmployeeService.status,
                    duration: newEmployeeService.duration,
                };
                return updatedServices;
            });

            setTimeout(() => {
                setEditingEmployeeInServiceIndex(null);
            }, 0);
        },
        [employees]
    );

    // Assume these imports are correct based on your project structure
    const onUpdateAppointment = async (event: any) => {
        event.preventDefault();
        setIsSaving(true);

        try {
            if (selectedServices.length === 0) {
                return toast.error("Please select at least one service");
            }

            // Extract form values
            const { startTime } = getFormValues(event.target);

            // Format and parse dates
            const formattedDate = format(selectedDate, "yyyy-MM-dd");
            const parsedDate = parse(formattedDate, "yyyy-MM-dd", new Date());
            const parsedTime = parse(startTime, "HH:mm", parsedDate);
            let currentStartDateTime = new Date(
                parsedDate.getFullYear(),
                parsedDate.getMonth(),
                parsedDate.getDate(),
                parsedTime.getHours(),
                parsedTime.getMinutes()
            );

            const appointmentGroup = getSpecificAppointmentGroup({
                appointmentId: selectedAppointmentEvent.appointment.id,
                phantomId: selectedAppointmentEvent.appointment.phantomId,
                specificDate: format(selectedAppointmentEvent.start, "yyyy-MM-dd"),
            });

            // Extract all appointment groups from each employee's schedule
            const appointmentGroupId = appointmentGroup.id;

            const appointmentData = selectedServices.map((service: any) => {
                // Calculate the end time by adding service duration to currentStartDateTime
                const endDateTime = addMinutes(currentStartDateTime, service.duration);

                const payload = {
                    startTime: format(currentStartDateTime, "yyyy-MM-dd HH:mm:ss"),
                    endTime: format(endDateTime, "yyyy-MM-dd HH:mm:ss"),
                    clientId: selectedClient.id,
                    shopId: Number(query.get("shopId")),
                    email: selectedClient.email,
                    name: selectedClient.name,
                    employeeId: service.employee.id,
                    serviceIds: [service.id],
                    appointmentGroupId: appointmentGroupId,
                } as any;

                currentStartDateTime = endDateTime;

                return payload;
            });

            if (isRepeating) {
                const isPhantom = !!appointmentGroup.phantomId;

                if (isPhantom) {
                    const data = {
                        appointmentRecurrenceId: appointmentGroup.appointmentRecurrence.id,
                        payload: {
                            appointmentData: appointmentData,
                            updateBlueprint: false,
                            appointmentGroupId: appointmentGroup.id,
                            frequency: appointmentGroup.appointmentRecurrence.frequency,
                            interval: appointmentGroup.appointmentRecurrence.interval,
                        },
                    };

                    return onEditAppointmentRepeating({
                        selectedServices,
                        parsedDate,
                        parsedTime,
                        selectedClient,
                        onUpdateThisAppointmentOnly: async () => {
                            data.payload.updateBlueprint = false;

                            await dispatch(
                                createAppointmentFromRecurrence(data) as any
                            ).unwrap();

                            // getSchedulesOfEmployees({
                            //   currentDate: startOfDay(selectedDate),
                            // });
                            setPendingAppointment(null);
                            setIsEditing(false);
                            toast.success("Appointment updated successfully");
                        },
                        onUpdateAllFutureAppointments: async () => {
                            // TODO: We may need to update the non phantom group as well (the original appointment)
                            data.payload.updateBlueprint = true;

                            await dispatch(
                                createAppointmentFromRecurrence(data) as any
                            ).unwrap();

                            // getSchedulesOfEmployees({
                            //   currentDate: startOfDay(selectedDate),
                            // });
                            setPendingAppointment(null);
                            setIsEditing(false);
                            toast.success("Appointment updated successfully");
                        },
                    });
                } else {
                    return onEditAppointmentRepeating({
                        selectedServices,
                        parsedDate,
                        parsedTime,
                        selectedClient,
                        onUpdateThisAppointmentOnly: async () =>
                            onUpdateNonPhantomAppointment(appointmentData),
                        onUpdateAllFutureAppointments: async () => {
                            await onUpdateNonPhantomAppointment(appointmentData);

                            await dispatch(
                                createAppointmentFromRecurrence({
                                    appointmentRecurrenceId:
                                    appointmentGroup.appointmentRecurrence.id,
                                    payload: {
                                        appointmentData: appointmentData,
                                        updateBlueprint: true,
                                        appointmentGroupId: appointmentGroup.id,
                                        frequency: appointmentGroup.appointmentRecurrence.frequency,
                                        interval: appointmentGroup.appointmentRecurrence.interval,
                                    },
                                }) as any
                            ).unwrap();
                        },
                    });
                }
            }

            return onUpdateNonPhantomAppointment(appointmentData);
        } catch (error) {
            console.error(error);
            toast.error("Failed to update appointment. Please try again.");
        } finally {
            // setIsSaving(false);
        }
    };
    const onUpdateAppointmentB = async (event: any) => {
        setIsSaving(true);

        try {
            if (event.services.length === 0) {
                return toast.error("Please select at least one service");
            }

            // Instead of destructuring startTime
            const startDateObj = new Date(event.start); // full date object

// Format and parse the date
            const formattedDate = format(startDateObj, "yyyy-MM-dd");
            const parsedDate = parse(formattedDate, "yyyy-MM-dd", new Date());

// Preserve the time from event.start
            const hours = startDateObj.getHours();
            const minutes = startDateObj.getMinutes();

            let currentStartDateTime = new Date(
                parsedDate.getFullYear(),
                parsedDate.getMonth(),
                parsedDate.getDate(),
                hours,
                minutes
            );

            // const appointmentGroup = getSpecificAppointmentGroup({
            //     appointmentId: event.appointment.id,
            //     phantomId: event.appointment.phantomId,
            //     specificDate: format(event.start, "yyyy-MM-dd"),
            // });


            // Extract all appointment groups from each employee's schedule
            const appointmentGroupId = event.appointment.appointmentGroup.id;
            const existingAppointmentId = event.appointment.id;
            console.log('appointmentGroupID found specific',appointmentGroupId)

            const appointmentData = event.services.map((service: any) => {
                // Calculate the end time by adding service duration to currentStartDateTime
                const endDateTime = addMinutes(currentStartDateTime, service.duration);

                const payload = {
                    // startTime: format(currentStartDateTime, "yyyy-MM-dd HH:mm:ss"),
                    // endTime: format(endDateTime, "yyyy-MM-dd HH:mm:ss"),

                    startTime: localDateToUtc(currentStartDateTime, shopTimeZone),
                    endTime: localDateToUtc(endDateTime, shopTimeZone),
                    // startTime: format(currentStartDateTime, "yyyy-MM-dd'T'HH:mm:ss"), // ✅ ISO-compatible
                    // endTime: format(endDateTime, "yyyy-MM-dd'T'HH:mm:ss"),
                    clientId: selectedClient.id,
                    shopId: Number(query.get("shopId")),
                    email: selectedClient.email,
                    name: selectedClient.name,
                    employeeId: service.employee.id,
                    serviceIds: [service.id],
                    appointmentGroupId: appointmentGroupId,
                } as any;

                currentStartDateTime = endDateTime;

                return payload;
            });

            // if (isRepeating) {
            //     const isPhantom = !!appointmentGroup.phantomId;
            //
            //     if (isPhantom) {
            //         const data = {
            //             appointmentRecurrenceId: appointmentGroup.appointmentRecurrence.id,
            //             payload: {
            //                 appointmentData: appointmentData,
            //                 updateBlueprint: false,
            //                 appointmentGroupId: appointmentGroup.id,
            //                 frequency: appointmentGroup.appointmentRecurrence.frequency,
            //                 interval: appointmentGroup.appointmentRecurrence.interval,
            //             },
            //         };
            //
            //         return onEditAppointmentRepeating({
            //             selectedServices,
            //             parsedDate,
            //             parsedTime,
            //             selectedClient,
            //             onUpdateThisAppointmentOnly: async () => {
            //                 data.payload.updateBlueprint = false;
            //
            //                 await dispatch(
            //                     createAppointmentFromRecurrence(data) as any
            //                 ).unwrap();
            //
            //                 // getSchedulesOfEmployees({
            //                 //   currentDate: startOfDay(selectedDate),
            //                 // });
            //                 setPendingAppointment(null);
            //                 setIsEditing(false);
            //                 toast.success("Appointment updated successfully");
            //             },
            //             onUpdateAllFutureAppointments: async () => {
            //                 // TODO: We may need to update the non phantom group as well (the original appointment)
            //                 data.payload.updateBlueprint = true;
            //
            //                 await dispatch(
            //                     createAppointmentFromRecurrence(data) as any
            //                 ).unwrap();
            //
            //                 // getSchedulesOfEmployees({
            //                 //   currentDate: startOfDay(selectedDate),
            //                 // });
            //                 setPendingAppointment(null);
            //                 setIsEditing(false);
            //                 toast.success("Appointment updated successfully");
            //             },
            //         });
            //     } else {
            //         return onEditAppointmentRepeating({
            //             selectedServices,
            //             parsedDate,
            //             parsedTime,
            //             selectedClient,
            //             onUpdateThisAppointmentOnly: async () =>
            //                 onUpdateNonPhantomAppointment(appointmentData),
            //             onUpdateAllFutureAppointments: async () => {
            //                 await onUpdateNonPhantomAppointment(appointmentData);
            //
            //                 await dispatch(
            //                     createAppointmentFromRecurrence({
            //                         appointmentRecurrenceId:
            //                         appointmentGroup.appointmentRecurrence.id,
            //                         payload: {
            //                             appointmentData: appointmentData,
            //                             updateBlueprint: true,
            //                             appointmentGroupId: appointmentGroup.id,
            //                             frequency: appointmentGroup.appointmentRecurrence.frequency,
            //                             interval: appointmentGroup.appointmentRecurrence.interval,
            //                         },
            //                     }) as any
            //                 ).unwrap();
            //             },
            //         });
            //     }
            // }



            console.log('appointment data',appointmentData)
            for (const appointment of appointmentData) {

                console.log('appointment updat data',appointment)
                // const existingAppointment = existingAppointments.find((appt: any) =>
                //     appt.services.some(
                //         (existingService: any) =>
                //             existingService.id === appointment.serviceIds[0]
                //     )
                // );

                await dispatch(
                    updateAppointment({
                        ...appointment,
                        appointmentId: existingAppointmentId,
                    }) as any
                ).unwrap()
                console.log('updated success')

                // if (existingAppointment) {
                //     // Update existing appointment
                //     updatePromises.push(
                //         dispatch(
                //             updateAppointment({
                //                 ...appointment,
                //                 appointmentId: existingAppointment.id,
                //             }) as any
                //         ).unwrap()
                //     );
                // } else {
                //     // Create new appointment
                //     createPromises.push(
                //         dispatch(createAppointment(appointment) as any).unwrap()
                //     );
                // }
            }





            // return onUpdateNonPhantomAppointment(appointmentData);
        } catch (error) {
            console.error(error);
            toast.error("Failed to update appointment. Please try again.");
        } finally {
            // setIsSaving(false);
        }
    };

    const handleUpdateAppointment=async ()=>{
        setIsEditing(false)
       // await onUpdateAppointmentB(updatingAppointment)
        setIsSaving(false)
    }

    const onUpdateNonPhantomAppointment = async (appointmentData: any[]) => {
        try {
            const appointmentsGroupToShow = getSpecificAppointmentGroup({
                appointmentId: selectedAppointmentEvent.appointment.id,
                phantomId: selectedAppointmentEvent.appointment.phantomId,
                specificDate: format(selectedAppointmentEvent.start, "yyyy-MM-dd"),
            });

            // Extract all appointment groups from each employee's schedule
            const existingAppointments = appointmentsGroupToShow.appointments;

            // Prepare lists to track operations
            const updatePromises = [];
            const createPromises = [];
            const deletePromises: any = [];

            for (const appointment of appointmentData) {
                const existingAppointment = existingAppointments.find((appt: any) =>
                    appt.services.some(
                        (existingService: any) =>
                            existingService.id === appointment.serviceIds[0]
                    )
                );

                if (existingAppointment) {
                    // Update existing appointment
                    updatePromises.push(
                        dispatch(
                            updateAppointment({
                                ...appointment,
                                appointmentId: existingAppointment.id,
                            }) as any
                        ).unwrap()
                    );
                } else {
                    // Create new appointment
                    createPromises.push(
                        dispatch(createAppointment(appointment) as any).unwrap()
                    );
                }
            }

            // Handle deleting appointments where all services are removed
            const serviceIdsInSelectedServices = selectedServices.map(
                (service) => service.id
            );
            const appointmentsToDelete = existingAppointments.filter(
                (appt: any) =>
                    !appt.services.some((existingService: any) =>
                        serviceIdsInSelectedServices.includes(existingService.id)
                    )
            );

            appointmentsToDelete.forEach((appt: any) => {
                deletePromises.push(
                    dispatch(deleteAppointment(appt.id) as any).unwrap()
                );
            });

            // Execute all promises
            await Promise.all([
                ...updatePromises,
                ...createPromises,
                ...deletePromises,
            ]);

            // getSchedulesOfEmployees({
            //   currentDate: startOfDay(selectedDate),
            // });
            setPendingAppointment(null);
            setIsEditing(false);

            toast.success("Appointment updated successfully");
        } catch (error) {
            console.error(error);
            toast.error("Failed to update appointment. Please try again.");
        } finally {
            setIsSaving(false);
        }
    };

    const onDeleteAppointmentGroup = async () => {
        const isPhantom = !!selectedAppointmentEvent.appointment.phantomId;
        setIsSaving(true);
        const shouldDeleteAppointmentGroup = window.confirm(
            "Are you sure you want to delete this appointment?"
        );
        if (!shouldDeleteAppointmentGroup) {
            return;
        }

        try {
            if (isRepeating && isPhantom) {
                await dispatch(
                    addAppointmentRecurrencyException({
                        appointmentRecurrenceId:
                        selectedAppointmentEvent.appointment.appointmentGroup
                            .appointmentRecurrenceId,
                        payload: {
                            date: selectedDate,
                        },
                    }) as any
                ).unwrap();
            } else {
                await dispatch(
                    deleteAppointmentGroup(
                        selectedAppointmentEvent.appointment.appointmentGroup.id
                    ) as any
                ).unwrap();
            }
            query.delete("appointmentId");
            query.delete("phantomId");
            navigate(`${Path.HOME}?${query.toString()}`);
            toggleAppointmentDrawer(false);
            // await getSchedulesOfEmployees({
            //   currentDate: startOfDay(selectedDate),
            // });

            toast.success("Appointment deleted successfully");
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete appointment. Please try again.");
        } finally {
            setIsSaving(false);
        }
    };

    const cancelEditing = () => {
        setSelectedServices(originalSelectedServices);
        setIsEditing(false);
        setPendingAppointment(null);
    };

    useEffect(() => {
        return () => {
            query.delete("appointmentId");
            query.delete("phantomId");
            query.delete("view");
            navigate(`${Path.HOME}?${query.toString()}`);
        };
    }, []);




    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                employeeSelectRef.current &&
                !employeeSelectRef.current.contains(event.target as Node)
            ) {
                setEditingEmployeeInServiceIndex(null);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [employeeSelectRef]);

    useEffect(() => {
        if (selectedAppointmentEvent) {
            updateSelectedServicesWithStartTimes({
                appointmentId,
                setSelectedServices,
            });
            setSelectedClient(selectedAppointmentEvent.client);
            setSelectedDate(selectedAppointmentEvent.start);
        }
    }, [selectedAppointmentEvent]);

    // Move the calculation outside useEffect into a memoized value
    const updatedAvailableServices = useMemo(() => {
        if (!employee || businessServices.length === 0) return [];

        return businessServices.map((category) => ({
            ...category,
            services: category.services.filter(
                (service: any) =>
                    !selectedServices.some(
                        (selectedService) =>
                            selectedService.businessService.id === service.id
                    )
            ),
        }));
    }, [employee, businessServices, selectedServices]);

    // Update the useEffect to use the memoized value
    useEffect(() => {
        if (employee && businessServices.length > 0) {
            setAvailableServices(updatedAvailableServices);
        }
    }, [employee, businessServices, updatedAvailableServices]);

    const onDateChange = useCallback(
        async (dateValue: any) => {

            console.log('new date value',dateValue)
            if (dateValue === selectedAppointmentEvent.start) {
                return;
            }

            const appointmentGroup = getSpecificAppointmentGroup({
                appointmentId: selectedAppointmentEvent.appointment.id,
                phantomId: selectedAppointmentEvent.appointment.phantomId,
                specificDate: format(selectedAppointmentEvent.start, "yyyy-MM-dd"),
            });

            console.log('app group',appointmentGroup)

            const startTimeElement = document.querySelector("#startTime") as any;
            const startTime = startTimeElement.value || "";
            // const formattedStartDate = format(dateValue, "yyyy-MM-dd");
            const formattedStartDate = dateValue
            const endTime = addMinutes(
                new Date(`${formattedStartDate}T${startTime}`),
                differenceInMinutes(
                    appointmentGroup.appointments[
                    appointmentGroup.appointments.length - 1
                        ].endTime,
                    appointmentGroup.appointments[0].startTime
                )
            );

            query.delete("date");
            query.set("date", format(dateValue, "yyyy-MM-dd"));
            navigate(`${Path.HOME}?${query.toString()}`);

            setUpdatingAppointment({
                ...selectedAppointmentEvent,
                pending: true,
                title: `Edit ${selectedClient.name}'s appointment`,
                start: new Date(`${formattedStartDate}T${startTime}`),
                end: new Date(endTime),
            });
        },
        [
            selectedAppointmentEvent,
            getSpecificAppointmentGroup,
            query,
            navigate,
            selectedClient.name,
        ]
    );

    const onTimeChange = useCallback(
        (event: any) => {
            const appointmentGroup = getSpecificAppointmentGroup({
                appointmentId: selectedAppointmentEvent.appointment.id,
                phantomId: selectedAppointmentEvent.appointment.phantomId,
                specificDate: format(selectedAppointmentEvent.start, "yyyy-MM-dd"),
            });

            const formattedStartDate = format(selectedDate, "yyyy-MM-dd");
            const formattedStartDateTime = `${formattedStartDate}T${event.target.value}`;
            const endTime = addMinutes(
                new Date(formattedStartDateTime),
                differenceInMinutes(
                    appointmentGroup.appointments[
                    appointmentGroup.appointments.length - 1
                        ].endTime,
                    appointmentGroup.appointments[0].startTime
                )
            );

            setPendingAppointment({
                ...selectedAppointmentEvent,
                title: `Edit ${selectedClient.name}'s appointment`,
                start: new Date(formattedStartDateTime),
                pending: true,
                end: new Date(endTime),
            });
        },
        [
            selectedAppointmentEvent,
            selectedDate,
            getSpecificAppointmentGroup,
            selectedClient.name,
        ]
    );

    // Memoize the appointment group for repeating operations
    const currentAppointmentGroup = useMemo(
        () =>
            getSpecificAppointmentGroup({
                appointmentId: selectedAppointmentEvent.appointment.id,
                phantomId: selectedAppointmentEvent.appointment.phantomId,
            }),
        [
            selectedAppointmentEvent.appointment.id,
            selectedAppointmentEvent.appointment.phantomId,
            getSpecificAppointmentGroup,
        ]
    );

    const handleMakeRepeating = useCallback(() => {
        closeDrawer();
        onMakeAppointmentRepeating({
            appointmentGroup: currentAppointmentGroup,
            onSave: async (frequency: RecurrenceFrequency, interval: number) => {
                await dispatch(
                    makeAppointmentRecurrence({
                        appointmentGroupId: currentAppointmentGroup.id,
                        frequency,
                        interval,
                    }) as any
                ).unwrap();

                toast.success(
                    `Appointment is now repeating every ${interval} week${
                        interval > 1 ? "s" : ""
                    }`
                );
            },
        });
    }, [
        currentAppointmentGroup,
        dispatch,
        closeDrawer,
        onMakeAppointmentRepeating,
    ]);

    const handleStopRepeating = useCallback(() => {
        closeDrawer();
        onStopAppointmentRepeating({
            appointmentGroup: currentAppointmentGroup,
            onSave: async () => {
                await dispatch(
                    stopAppointmentRecurrence({
                        appointmentRecurrenceId:
                        currentAppointmentGroup.appointmentRecurrence.id,
                        date: selectedDate,
                    }) as any
                ).unwrap();

                toast.success("Appointment is no longer repeating");
            },
        });
    }, [
        currentAppointmentGroup,
        selectedDate,
        dispatch,
        closeDrawer,
        onStopAppointmentRepeating,
    ]);

    return {
        isEditing,
        setIsEditing,
        onUpdateAppointment,
        selectedClient,
        setSelectedClient,
        onHandleClientChange,
        clients,
        selectedServices,
        setSelectedServices,
        editingEmployeeInServiceIndex,
        setEditingEmployeeInServiceIndex,
        employeeSelectRef,
        employees,
        handleEmployeeChange,
        serviceSelectValue,
        onHandleAddService,
        availableServices,
        selectedDate,
        setSelectedDate,
        isDateInputFocused,
        isRepeating,
        setIsDateInputFocused,
        onRemoveService,
        getSpecificAppointmentGroup,
        cancelEditing,
        onDeleteAppointmentGroup,
        handleClientSearch,
        onTimeChange,
        onDateChange,
        handleMakeRepeating,
        handleStopRepeating,
        specificAppointmentGroup,
        isSaving,
        saleForSelectedAppointment,
        handleUpdateAppointment,
        updatingAppointment,
        setUpdatingAppointment
    };
};
